const indexItems = [
  { name: '电影', icon: 'ri-film-line', count: '3,200+', desc: '院线大片与经典佳作' },
  { name: '电视剧', icon: 'ri-tv-2-line', count: '5,800+', desc: '热播剧集一网打尽' },
  { name: '综艺', icon: 'ri-emotion-laugh-line', count: '1,500+', desc: '热门综艺欢乐不断' },
  { name: '动漫', icon: 'ri-ghost-smile-line', count: '2,100+', desc: '日漫国漫全都有' },
  { name: '纪录片', icon: 'ri-earth-line', count: '980+', desc: '探索世界的精彩' },
  { name: '短剧', icon: 'ri-vidicon-line', count: '3,600+', desc: '快节奏微短剧' },
  { name: '少儿', icon: 'ri-parent-line', count: '1,200+', desc: '亲子时光好选择' },
  { name: '体育', icon: 'ri-basketball-line', count: '650+', desc: '赛事集锦与回顾' },
  { name: '音乐', icon: 'ri-music-2-line', count: '820+', desc: 'MV与演唱会合集' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-grid-line"></i>
            <span className="whitespace-nowrap">全部分类</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">分类索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按分类浏览内容，快速找到你感兴趣的视频</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.name}
              href="#index"
              className="group p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200/60 hover:bg-primary-50/30 transition-all cursor-pointer text-center"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.name}</h3>
              <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
              <span className="inline-block mt-2 text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full">{item.count}部</span>
            </a>
          ))}
          <div className="col-span-2 sm:col-span-3 lg:col-span-1 p-5 rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 text-background-50 text-center flex flex-col items-center justify-center">
            <i className="ri-add-circle-line text-2xl mb-2"></i>
            <span className="text-sm font-semibold whitespace-nowrap">更多分类</span>
            <span className="text-xs text-background-50/80 mt-1 whitespace-nowrap">持续扩展中</span>
          </div>
        </div>
      </div>
    </section>
  );
}